import { connect } from "react-redux"
import { Button, Card, CardBody, CardHeader, Col, Container, DatePicker, Form, FormInput, FormSelect, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalBody, Row } from "shards-react"
import ReactTable from "react-table"
import React, { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { formatNumberAmount } from "../../../utils/general";
import Multiselect from "multiselect-react-dropdown";
import { NavgationPageLocationKey } from "../../../utils/constants";
import { get_client_balance_list, get_client_status_list } from "../../../redux/actions/subscriber/subscriberUsers";

function ViewClientBalance({
    get_client_status_list, get_client_balance_list,
    clientStatusList, clientBalanceList,
}) {

    const initialState = {
        pageSizeOptions: [5, 10, 15, 20, 25, 30],
        pageSize: 20,
        from: '',
        to: '',
        clientName: '',
        clientId: '',
        status: '',
        color: '',
    }

    const clientColor = ["GREEN", "ORANGE", "RED"];
    const defaultColor = [{ cat: 'All', key: 'All' }];
    const defaultStatus = [{ cat: 'All Statuses', key: 'All' }];
    const [formData, setFormData] = useState({ status: '' })
    const [state, setState] = useState({...initialState});

    const [statusDropdownOptions, setStatusDropdownOptions] = useState([]);
    const [selectedValues, setSelectedValues] = useState([...defaultStatus]);

    const [colorDropdownOptions, setColorDropdownOptions] = useState([]);
    const [selectedColor, setSelectedColor] = useState([...defaultColor]);

    const tableRef = useRef()
    const [tableData, setTableData] = useState([
        //...clientBalanceList
    ]);
    const history = useHistory();

    const onChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };

    const { pageSize, pageSizeOptions } = state;
    const tableColumns = [
        {
            Header: "Client ID",
            accessor: "refNum",
            //maxWidth: 100,
            minWidth: 140,
            //TODO - need to fix it
            Cell: row => <>
                <img src="./icons/edit-square.svg" role="button" height="17.5" width="17.5" className="mr-2"
                    onClick={(e) => { openClientBalanceInNewTab(e, row.original.refNum) }}></img>
                <a href="/client-balances-details"
                    onClick={(e) => { openClientBalanceInNewTab(e, row.original.refNum) }}
                    onContextMenu={(e) => onContextMenuInvoiceChange(e, row.original.refNum)}>
                    {`${row.original.refNum}`}
                </a>
            </>
        },
        {
            Header: "Name",
            accessor: "clientName",
            //maxWidth: 110,
            minWidth: 170,
            Cell: row => <span className="w-100 text-left">{row.original.clientName}</span>
        },
        {
            Header: "Status",
            accessor: "status",
            minWidth: 100,
            //maxWidth: 100,
            classNames: 'text-left',
            Cell: row => <span className="w-100">{row.original.status}</span>
        },
        {
            Header: "Colour Code",
            accessor: "colorCode",
            //maxWidth: 100,
            minWidth: 100,
        },
        {
            Header: "Retainer Required",
            accessor: "retainerRequired",
            //maxWidth: 150,
            minWidth: 160,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.retainerRequired, 'en-US', 2, 2)}</span>
        },
        {
            Header: "Retainer Held",
            accessor: "retainerHeld",
            //maxWidth: 150,
            minWidth: 150,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.retainerHeld, 'en-US', 2, 2)}</span>
        },
        {
            Header: "Outstanding Balance",
            accessor: "outstandingBalance",
            //maxWidth: 200,
            minWidth: 180,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.outstandingBalance, 'en-US', 2, 2)}</span>
        },
        {
            Header: "Client Balance",
            accessor: "clientBalance",
            //maxWidth: 120,
            minWidth: 120,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.clientBalance, 'en-US', 2, 2)}</span>
        },
        {
            Header: "Outstanding Invoices",
            accessor: "outstandingInvoices",
            //maxWidth: 180,
            minWidth: 180,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.outstandingInvoices, 'en-US', 2, 2)}</span>
        }
    ]

    const reset = () => {
        setState({...initialState})
        const selectedStatus = statusDropdownOptions.map(status => status.key).toLocaleString()
        const selectedColour = colorDropdownOptions.map(status => status.key).toLocaleString()
        setSelectedValues([...statusDropdownOptions])
        setSelectedColor([...colorDropdownOptions]);
        get_client_balance_list(initialState.clientName, initialState.clientId, selectedStatus, selectedColour);
    }

    const onSearch = (e) => {
        e.preventDefault()
        const selectedStatus = selectedValues.map(status => status.key).toLocaleString();
        const selectedColour = selectedColor.map(status => status.key).toLocaleString()
        get_client_balance_list(state.clientName, state.clientId, selectedStatus, selectedColour );
    }
   
    useEffect(() => {
        let clientStatus = clientStatusList.map(status => ({
            cat: status,
            key: status
        }))

        setStatusDropdownOptions([{
            cat: 'All Statuses',
            key: 'All'
        }, ...clientStatus])

        setSelectedValues([{
            cat: 'All Statuses',
            key: 'All'
        }, ...clientStatus])
    }, [clientStatusList])

    useEffect(() => {
        get_client_status_list();
        get_client_balance_list();

        let clientColors = clientColor.map(color => ({
            cat: color,
            key: color
        }))
        setColorDropdownOptions([{
            cat: 'All',
            key: 'All'
        }, ...clientColors])

        setSelectedColor([{
            cat: 'All',
            key: 'All'
        }, ...clientColors]);

    }, [])

    useEffect(() => {
        setTableData([...clientBalanceList])
    }, [clientBalanceList])

    // Added by nipul for parameter less flow
    function navigateToClientBalance(e, refId, clientName){
        e.preventDefault(); 
        history.push({
            pathname: `/client-balances-details`,
            state: { refNum: refId, clientName: clientName }
        });
        return false;
    }

    function onContextMenuInvoiceChange(e, refId){
        if(e.type === 'contextmenu'){
            localStorage.setItem(NavgationPageLocationKey.clientBalanceAddEdit, refId);
        }
    }

    function openClientBalanceInNewTab(e, refId) {
        e.preventDefault();
        localStorage.setItem(NavgationPageLocationKey.clientBalanceAddEdit, refId);
        window.open('/client-balances-details', '_blank');
    }

    return (
    <Container fluid className="main-content-container px-4 pb-4">
        <div className="page-header tableSearch flex-column flex-md-row py-2 d-flex justify-content-end bg-white mt-4 ">
            <div className="d-flex align-items-center p-2">
                <FormInput name='clientName' value={state.clientName}
                    onChange={onChange} placeholder="Client Name"
                />
            </div>

            <div className="d-flex align-items-center p-2">
                <FormInput name='clientId' value={state.clientId}
                    onChange={onChange} placeholder="Client ID"
                />
            </div>

            <div className="d-flex align-items-center p-2">
                <Multiselect
                    hideSelectedList
                    displayValue="cat"
                    placeholder={`Status: ${(selectedValues && selectedValues.length > 0 && selectedValues[0].key === 'All') ? 'All Statuses' : selectedValues.map(val => val.key).toString()}`}
                    onKeyPressFn={function noRefCheck() { }}
                    onSearch={function noRefCheck() { }}
                    onRemove={function noRefCheck(selectedOptions, item) {
                        if (item.key === 'All') {
                            setSelectedValues([])
                        } else {
                            selectedOptions = selectedOptions.filter(option => option.key !== 'All')
                            setSelectedValues([...selectedOptions])
                        }
                    }}
                    onSelect={function noRefCheck(selectedOptions, seletedItem) {
                        if (seletedItem.key === 'All') {
                            setSelectedValues([...statusDropdownOptions])
                        } else {
                            if (selectedOptions.length === statusDropdownOptions.length - 1) {
                                selectedOptions = [...statusDropdownOptions]
                            }
                            setSelectedValues([...selectedOptions])
                        }

                    }}
                    options={[
                        ...statusDropdownOptions
                    ]}
                    selectedValues={[...selectedValues]}

                    showCheckbox />
            </div>

            <div className="d-flex align-items-center p-2">
                <Multiselect
                    hideSelectedList
                    displayValue="key"
                    placeholder={`Colour Code: ${(selectedColor && selectedColor.length > 0 && selectedColor[0].key === 'All') ? 'All' : selectedColor.map(val => val.key).toString()}`}
                    onKeyPressFn={function noRefCheck() { }}
                    onSearch={function noRefCheck() { }}
                    onRemove={function noRefCheck(selectedOptions, item) {
                        if (item.key === 'All') {
                            setSelectedColor([])
                        } else {
                            selectedOptions = selectedOptions.filter(option => option.key !== 'All')
                            setSelectedColor([...selectedOptions])
                        }
                    }}
                    onSelect={function noRefCheck(selectedOptions, seletedItem) {
                        if (seletedItem.key === 'All') {
                            setSelectedColor([...colorDropdownOptions])
                        } else {
                            if (selectedOptions.length === colorDropdownOptions.length - 1) {
                                selectedOptions = [...colorDropdownOptions]
                            }
                            setSelectedColor([...selectedOptions])
                        }

                    }}
                    options={[
                        ...colorDropdownOptions
                    ]}
                    selectedValues={[...selectedColor]}

                    showCheckbox />
            </div>

            <div className="d-flex align-items-center justify-content-end p-2">
                <Button className="mx-2 py-2 my-2" size='sm' theme="accent"
                    onClick={onSearch}
                >Search</Button>
                <Button className="mx-2 py-2 my-2" size='sm' theme="accent"
                    onClick={reset}
                >Reset</Button>
            </div>
        </div>

        <Card className="tableCard p-0">
            <CardHeader className="p-0">
                <Container fluid className="file-manager__filters border-bottom">
                    <Row>
                        {/* Filters :: Page Size */}
                        <Col lg="2" className="file-manager__filters__rows d-flex justify-content-center justify-content-md-start align-items-center cl-2">
                        </Col>
                        <Col lg="3" className="d-flex align-items-center">
                        </Col>
                        <Col lg="6" className="file-manager__filters__search d-flex justify-content-md-start col-7">
                        </Col>

                        <Col lg="1" className="file-manager__filters__rows d-flex justify-content-center justify-content-md-end align-items-center col-2">
                            <span>Show</span>
                            <FormSelect
                                size="sm"
                                name='pageSize'
                                value={state.pageSize}
                                onChange={onChange}
                            >
                                {pageSizeOptions.map((size, idx) => (
                                    <option key={idx} value={size}>
                                        {size} rows
                                    </option>
                                ))}
                            </FormSelect>
                        </Col>
                    </Row>
                </Container>
            </CardHeader>
            <CardBody className="p-0">
                <div className="">
                    <ReactTable
                        ref={tableRef}
                        columns={tableColumns}
                        data={tableData}
                        pageSize={Number(pageSize)}
                        showPageSizeOptions={false}
                        resizable={false}
                        noDataText="No results found"
                        previousText={<i class='fa fa-chevron-left' aria-hidden='true'></i>}
                        nextText={<i class='fa fa-chevron-right' aria-hidden='true'></i>}
                    />
                </div>
            </CardBody>
        </Card>
    </Container>)
}

const mapStateToProps = (state) => ({
    clientStatusList: state.subscriberUsers.clientStatusList,
    clientBalanceList: state.subscriberUsers.clientBalanceList,
})
export default connect(mapStateToProps, {
    get_client_status_list,
    get_client_balance_list,
})(ViewClientBalance)